export default __webpack_public_path__ + "static/images/app-phone-3x-b3c2a6e66e7d4732986e9407b5796b3d.png";